import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Defensive: unregister any leftover service workers from prior deployments
// to prevent the "page not updating even after hard refresh" issue users hit
// when a previous preview domain installed a SW that cached the SPA shell.
const SITE_VERSION = "2026-06-24-v2";
try {
  const stored = typeof localStorage !== "undefined" ? localStorage.getItem("ts-site-version") : null;
  if (stored !== SITE_VERSION) {
    if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    if (typeof caches !== "undefined") {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
    }
    if (typeof localStorage !== "undefined") {
      try { localStorage.setItem("ts-site-version", SITE_VERSION); } catch (_) {}
    }
    if (stored !== null && typeof window !== "undefined") {
      window.location.reload();
    }
  }
} catch (_) {}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
